import enUS from 'date-fns/locale/en-US';
import { format, utcToZonedTime } from 'date-fns-tz';

/**
 *
 * @param timeZone IANA format timezone name (ex: 'America/New_York')
 * @returns abbreviation as formatted by date-fns-tz (ex: 'EST')
 */
export function timezoneToAbbrString(timeZone: string, date?: string | number | Date) {
    return format(utcToZonedTime(date ?? new Date(), timeZone), 'zzz', {
        timeZone,
        locale: enUS,
    });
}
